import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { leagueIds, sportIds, teamIds } from 'src/constants/personalizationIds'

export default (props) => {
  return (
    <USTemplateDefault
      location={props.location}
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/Rockets_AT&T_2021_LP_15s.mp4'}
      title="Watch live Rockets basketball"
      subtitle="Plus get Houston sports talk and more. Regional restrictions apply."
      networkSet="basketball"
      customNetworks={['spacecity']}
      sportId={sportIds.Basketball}
      leagueId={leagueIds.NBA}
      teamId={teamIds['Houston Rockets']}
    />
  )
}
